import React from 'react'
import PropTypes from 'prop-types'

import pluralize from 'pluralize'
import { Card, List } from 'semantic-ui-react'

import CardProperty from 'Components/CardProperty'
import Permissions from 'Components/Permissions'

import { getFormattedDateString } from 'Global/Helpers/timeHelpers'

const RugCardDetailedMeta = ({ rug }) => (
  <Permissions
    permissions={['rug.field.dateScanned', 'rug.field.pictureCount']}
    render={() => (
      <Card.Content extra>
        <List>
          {rug.dateScanned && (
            <Permissions
              permissions="rug.field.dateScanned"
              render={() => (
                <CardProperty icon="calendar check" popUpContent="Date Scanned">
                  {getFormattedDateString(rug.dateScanned)}
                </CardProperty>
              )}
            />
          )}

          {rug.pictures.length > 0 && (
            <Permissions
              permissions="rug.field.pictureCount"
              render={() => (
                <CardProperty icon="file image outline" popUpContent="Number of Pictures">
                  {`${rug.pictures.length} ${pluralize('picture', rug.pictures.length)}`}
                </CardProperty>
              )}
            />
          )}
        </List>
      </Card.Content>
    )}
  />
)

RugCardDetailedMeta.propTypes = {
  rug: PropTypes.object.isRequired,
}

export default RugCardDetailedMeta
